import { LanguageType } from '../../../types/language';

export type DeviceInfo = {
  os: string;
  deviceId: string | null;
  appVersion: string | null;
};

// 鏈接類型
export enum LinkType {
  REGISTER = '01', // 註冊下載
  INFO = '02', // 申請半流程（授信）
  ALL = '03', // 申請全流程（授信+提現）但部分位置依旧引导回App中
  FESTIVAL = '88', // 年宵活動
  WHATSAPP = '99', // whatsapp補充文件上傳
}

// byClaude-start 2026-08-13 13:56:41 申请表单类型：FULL_FORM 代表全流程（授信+提现），替代原 linkType=05
export enum ApplicationForm {
  FULL_FORM = 'FULL_FORM', // 全流程表单（授信+提现）
  LEAD_FORM = 'LEAD_FORM', // 落地页表单（跳转官网）
}
// byClaude-end 2026-08-13 13:56:41

type InitialOptions = {
  initLangCallBack?: (lang: LanguageType) => void;
};

export enum Platform {
  Default = 'Default', // 默认，一般不会选中
  Crefit = 'Crefit', // 原生 App 中的Webview
  MyLink = 'MyLink', // MyLink App 中的 Webview
  EkycWebview = 'EkycWebview', // 原生中的 Ekyc 中的 Webview
  PCWebClient = 'PCWebClient', // PC 端的浏览器
  MobileWebClient = 'MobileWebClient', // 移动端浏览器 H5
}

export type IOSActivityContentState = {
  buttonName: string;
  clickEvent: {
    event: string;
    isLogin: string;
    urlCode: string;
    urlPath: string;
    param: Record<string, string>;
    trace?: {
      eventName: string;
    };
  };
  currentNodeCode: string;
  buttonCode: string;
  eventTime?: number;
  currentNodeName: string;
  progress: number;
  title: string;
  buttonClickFlag: string;
};

export type NativeApi = {
  env?: 'hk' | 'dev-hk';
  name: Platform;
  token: string;
  deviceId?: string;
  hardwareId?: string;
  isNewVersion?: boolean; // 是否新版
  platformInfo?: any;
  utils?: any;
  h5LinkType?: LinkType; // H5 的链接类型，申請流程/全流程
  uiVersion?: string; // UI版本，来自原始，可能会通过网络得到
  layoutVersion?: string; // Layout版本，来自原始，可能会通过网络得到
  headerParams?: any;
  init?: (option?: InitialOptions) => Promise<void> | void;
  setToken?: (token: string) => void; // 浏览器端在登录了之后，需要在神策中设置userId，才能关联数据
  getToken: () => string | Promise<string>;
  getDeviceId?: () => string | Promise<string>;
  getHardwareId?: () => string | Promise<string>;
  getRequestHeader?: () => any;
  setRequestHeader?: (header: any) => void;
  getLanguage: () => LanguageType | Promise<LanguageType>;
  closeWindow: (obj?: any) => void;
  getSystemInfo?: () => any | Promise<any>;
  gotoWhatsApp?: () => void;
  getThirdPartyUserInfo?: () => Promise<any>;
  selectContact?: () => Promise<any>; // 通过原生Api选择联系人
  saveInfo?: (obj: any) => void; // 保存当下平台所需的任何信息，在需要的时候读取
  reLogin?: (options?: { noCloseWindow?: boolean }) => string | Promise<string>; // 重新登录
  getStatusBarHeight?: () => number | Promise<number>;
  getNativeAppVersion?: () => CreFitAppVersion | Promise<CreFitAppVersion> | undefined;
  gotoMakeCall?: (phone?: string) => void; // 跳转到拨打电话页面
  fbTrackEvent?: (eventName: string, eventParam?: any) => void; // facebook埋点
  afTrackEvent?: (eventName: string, eventParam?: any) => void; // Appsflyer埋点
  gotoRate?: (
    Source_Type: 'HomePage_CV' | 'Withdrawal_success' | '7d_interest_tree_settle'
  ) => void; // 跳转到评分页面
  setH5LinkType?: (type: LinkType) => void; // 设置H5的链接类型
  setIsNewVersion?: (isNewVersion: boolean) => void; // 设置是否是新版UI
  getIsNewVersion?: () => PromiseLike<boolean> | boolean; // 是否是新版UI
  getNativeLayoutVersion?: () => PromiseLike<string> | string; // 获取原生Layout版本
  getUIVersion?: () => string; // 获取原生UI版本
  goCmcFaceVerify?: () => Promise<boolean>; // 跳转到CMC人脸验证页面, true: 成功, false: 失败, reject: 没有原生方法
  kkOpenNewWebview?: (url: string) => boolean; // 在新 Webview 中打开链接, true: 已调用原生方法, false: 未调用
  kkStartActivityNode?: (objMsg: {
    productType: string;
    contentState: IOSActivityContentState;
  }) => void;
};

// 原生App的版本号，用到关键版本号再增加，会逐步增加，尽量不要将其作为Key值，可以用逻辑判断来处理
export enum CreFitAppVersion {
  V175 = '1.7.5', // 0704-1.7.5 原生版本
  V191 = '1.9.1', // 2501--1.9.1 原生版本
}

// Contains claude-generated edits.
